const selectSuggestedPrice = (programType, programSuggestedPrices, tenantConfig, basePrice) => {
    const suggestedPrices = programSuggestedPrices || (tenantConfig.program && tenantConfig.program.suggestedPrices);

    if (programType === 'fund' && suggestedPrices && suggestedPrices.length > 0) {
        return suggestedPrices[0];
    }
    return basePrice;
};

export default selectSuggestedPrice;
